<template>
  <v-dialog :model-value="model" max-width="1030" persistent>
    <v-card>
      <v-card-title class="pa-2 pt-2 pb-1">
        <v-row v-if="closeable" no-gutters justify="end">
          <v-col v-ripple cols="auto" class="pointer px-2" @click="close">
            <v-icon :size="18" class="ico-45-deg" color="szGrey"> $tagClose </v-icon>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text class="sz-white sz-primary-grey--text">
        <v-row no-gutters>
          <v-col v-if="icon" :cols="getIconColumnWidth($vuetify.display.xs)" class="pl-0 pl-md-5">
            <v-icon :size="37" color="szRed"> $alert </v-icon>
          </v-col>
          <v-col :cols="getMessageColumnWidth($vuetify.display.xs)">
            <v-row no-gutters>
              <v-col cols="12">
                <slot name="header" />
              </v-col>
              <v-col v-if="divider" cols="12" class="my-5">
                <v-divider />
              </v-col>
              <v-col cols="12" class="f-18 sz-primary-grey--text font-weight-regular">
                <slot name="footer" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  closeable: {
    type: Boolean,
    default: true
  },
  icon: {
    type: Boolean,
    default: true
  },
  divider: {
    type: Boolean,
    default: true
  }
})

const model = defineModel({
  type: Boolean
})

const emit = defineEmits(['close'])

function close() {
  model.value = false
  emit('close')
}

function getIconColumnWidth(isXs: boolean): number {
  return isXs ? 2 : 1
}

function getMessageColumnWidth(isXs: boolean): number {
  if (!props.icon) {
    return 12
  }
  return isXs ? 10 : 11
}

defineExpose({
  close
})
</script>
